import { getHubBrand } from '@/store';
import type { BrandSource } from './types';
import { namesABrand } from './types';

// gloss
export const storeBrandSource: BrandSource = {
  name: 'store',
  resolve: () => {
    const hub = getHubBrand();
    const identifiers = {
      uuid: hub.uuid,
      brandID: hub.brandID,
      code: hub.code ?? hub.brandName,
    };

    return namesABrand(identifiers) ? identifiers : null;
  },
};
